import React, { useEffect, useState } from "react";
import Error from "../Error";

import { useFieldArray, useForm } from "react-hook-form";
import ExtraForm from "./ExtraForm";

import * as yup from "yup";
import { connect } from "react-redux";
import {
  newProduct,
  newSection,
  resetCreate,
  resetCreateSection,
} from "../../../store/actions/RestaurantActions";
import ModalLoading from "../../common/ModalLoading";
import ModalAlert from "../../common/ModalAlert";
import { Redirect } from "react-router-dom";
import { ADMIN_MENU_PATH } from "../../../constants/paths";

const FILE_SIZE = 300000;
const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg"];

const schema = yup.object().shape({
  image: yup
    .mixed()
    .test("fileExists", "Se requiere registrar una imagen", function (files) {
      return files.length > 0;
    })
    .test(
      "fileSize",
      "Archivo es muy grande (Máximo peso: 300KB)",
      function (files) {
        if (files.length <= 0) return false;

        const file = files[0];
        return file.size <= FILE_SIZE;
      }
    )
    .test("fileType", "Tipo de archivo no soportado", function (files) {
      if (files.length <= 0) return false;

      const file = files[0];
      return SUPPORTED_FORMATS.includes(file.type);
    }),
  title: yup.string().required("Campo requerido"),
  available: yup.boolean(),
});

const NewSectionForm = ({
  restaurantId,
  loading,
  success,
  error,
  newSection,
  resetCreateSection,
}) => {
  const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);

  const {
    control,
    register,
    errors,
    handleSubmit,
    reset,
    getValues,
    formState,
  } = useForm({
    validationSchema: schema,
  });

  var subtitle;

  useEffect(() => {
    if (success) setAlertModalIsOpen(true);
  }, [success]);

  const readURL = (e) => {
    const input = e.target;

    if (input.files && input.files[0]) {
      const container = document.getElementById("img");
      container.innerHTML = "";

      const file = input.files[0];
      const img = document.createElement("IMG");
      img.classList.add("image-preview");
      img.src = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(img.src); // free memory
      };

      container.appendChild(img);
    }
  };

  const closeAlertModal = () => {
    setAlertModalIsOpen(false);
  };

  const create = (values) => {
    newSection(values, restaurantId);
  };

  if (success) {
    resetCreateSection();
    return <Redirect to={ADMIN_MENU_PATH}></Redirect>;
  }

  return (
    <div>
      <ModalLoading
        message="Se están realizando los cambios en la base de datos. Espere un momento por favor."
        closeModal={null}
        modalIsOpen={loading}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        subtitle=""
        title="Creando el producto"
        loading
      ></ModalLoading>
      <ModalAlert
        message="Se realizaron los cambios de forma exitosa. Puedes seguir haciendo cambios."
        closeModal={closeAlertModal}
        modalIsOpen={alertModalIsOpen}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        subtitle=""
        title="Éxito creando el producto"
        loading
      ></ModalAlert>
      <form
        id="section-form"
        className="section-form flex border-2 border-gray-200 p-4 rounded-md mb-4 relative"
        onSubmit={handleSubmit(create)}
      >
        <label id="img" htmlFor="image">
          <img
            src="https://via.placeholder.com/64"
            className="image-preview"
          ></img>
        </label>
        <input
          className="hidden"
          type="file"
          id="image"
          name="image"
          ref={register}
          onChange={readURL}
        ></input>
        <div className="w-full">
          <div className="mb-4 w-full input">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="title"
            >
              Nombre
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              name={"title"}
              ref={register}
              placeholder="Nombre del producto"
            />
            <Error error={errors ? errors.title : null} left></Error>
          </div>
          <div className="mb-4 w-full input">
            <div className="flex items-center">
              <input
                className="border rounded focus:outline-none focus:shadow-outline"
                type="checkbox"
                name={"available"}
                ref={register}
                defaultChecked={true}
              />
              <label
                className="block text-gray-700 text-sm font-bold ml-2"
                htmlFor="title"
              >
                Disponible
              </label>
            </div>
            <Error error={errors ? errors.available : null} left></Error>
          </div>
          <Error error={errors ? errors.image : null} left></Error>
        </div>
      </form>
      <div className="w-full flex justify-end">
        <button
          type="submit"
          disabled={loading ? true : false}
          form="section-form"
          className="block bg-brand-300 rounded-md text-brand-800 py-2 px-4 text-sm font-bold border-2 border-brand-700"
        >
          Crear sección
        </button>
      </div>
      <Error error={error} left></Error>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.restaurant.sectionActions.create,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newSection: (section, restaurantId) =>
      dispatch(newSection(section, restaurantId)),
    resetCreateSection: () => {
      dispatch(resetCreateSection());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSectionForm);
